import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  margin: 0 auto auto;

  > div {
    position: absolute;
    top: 25%;
  }
`;
